import React, { createContext, useContext, useState } from 'react';

const BuyNumberContext = createContext(null);

export const BuyNumberProvider = ({ children }) => {
	const [isOpen, setIsOpen] = useState(false);
	const [config, setConfig] = useState({});
	const handleOpenBuy = ({ serviceSlug, serviceExtraId, countryId, countrySlug, countryExtraId, initPrice }) => {
		setConfig({ serviceSlug, serviceExtraId, countryId, countrySlug, countryExtraId, initPrice })
		setIsOpen(true);
	};
	const handleCloseBuy = () => {
		setConfig({})
		setIsOpen(false);
	};
	const value = {
		config,
		isOpen,
		handleOpenBuy,
		handleCloseBuy,
	};

	return (
		<BuyNumberContext.Provider value={value}>
			{children}
		</BuyNumberContext.Provider>
	);
};

export const useBuyNumber = () => {
	const context = useContext(BuyNumberContext);
	if (!context) {
		throw new Error('useBuyNumber must be used within BuyNumberProvider');
	}
	return context;
};

export default BuyNumberContext;
